import { renderValue } from './utils';

import type { InfoSectionProps } from './types';

export const InfoSection = ({ title, rows }: InfoSectionProps) => {
    return (
        <section className="w-full py-5">
            <h2 className="text-[16px] md:text-[18px] font-bold tracking-tight text-black">{title}</h2>
            <dl className="mt-3 flex flex-col gap-2">
                {rows.map(({ label, value }) => (
                    <div key={label} className="flex items-center justify-between gap-3 py-2">
                        <dt className="shrink-0 text-[14px] md:text-[15px] font-medium text-black/55 whitespace-nowrap">
                            {label}
                        </dt>
                        <dd className="min-w-0 flex-1 text-[14px] md:text-[15px] font-semibold text-black text-right break-words">
                            {renderValue(value)}
                        </dd>
                    </div>
                ))}
            </dl>
        </section>
    );
};
